<template>
  <div class="warning-wrapper" v-if="getshowModule().length > 0">
    <FTItem class="wrappertop"
    v-for="(item, index) in getshowModule()"
    :content="item"
    :key="index">
    </FTItem>
  </div>
</template>

<script>
import FTItem from '@/components/Fund-Tip-item.vue';
import FundTypeSearch from '@/utils/FundTypeSearch';

export default {
  name: 'WarningBar',
  props: {
    topSpline: {
      type: String,
    },
  },
  computed: {
  },
  components: {
    FTItem,
  },
  data() {
    return {
      contentList: ['根据证监会规定，3月30日起，基金公司将对旗下部分产品持续持有期少于7个自然日的投资者收取不低于1.5%的赎回费，点此了解详情>>>', '策略选基抢占年前最后上车机会策略选基抢占年前最后上车机会'],
      closable: true,
      showIcon: true,
      show: true,
      warn_red_src: '@/assets/warn-tip-red.png',
      close_src: '@/assets/warn-tip-close.png',
    };
  },
  created() {
    this.fundCode = this.$store.state.native.fund.fundCode;
    this.handleDefault();
  },
  methods: {
    render() {

    },
    isNewFund() {
      const { fundType } = this.$store.state.native.fund;
      return FundTypeSearch.isNewFund(fundType);
    },
    handleDefault() {},
    clickAction() {

    },
    getshowModule() {
      return [
        {
          HotKey: '',
          Id: null,
          Link: null,
          Mark: null,
          Media: null,
          MediaType: 0,
          Mode: '0',
          ReadDecription: null,
          ReadTitle: '认购期仅供参考，以基金公司公告为准。为避免基金认购提前结束，建议加入自选并及时关注募集结束时间。',
          ReadType: 0,
          ReadTypeModel: { Type: 0, Name: '市场', Color: '#F5A623' },
          SHOWPOSITION: 0,
          Sort: 0,
          SubHotKey: '',
          SubTitle: '',
          Tip: '',
          Title: '认购期仅供参考，以基金公司公告为准。为避免基金认购提前结束，建议加入自选并及时关注募集结束时间。',
          UpdateTimeStr: null,
          show: '1',
        },
      ];
    },
  },
};
</script>

<style scoped lang="less">
.warning-wrapper {
  padding-left: 24px;
  padding-right: 24px;
  align-items: center;
}
.wrapper {
  background: #fff7bc;
  display: flex;
  padding-left: 25px;
  border-radius: 12px;
}

.wrappertop {
  margin-bottom: 24px;
  background: #fff7bc;
  padding-left: 25px;
  border-radius: 12px;
  display: flex;
}

.text-wrapper {
  line-height: 24px;
  flex: 1;
  align-items: center;
}

.content {
  font-family: PingFangSC-Regular;
  font-size: 24px;
  color: #ff4400;
}

.warn_red_img {
  width: 22px;
  height: 22px;
  margin-right: 10px;
}

.close_view {
  width: 50px;
  padding-right: 20px;
  text-align: right;
}

.close_img {
  width: 26px;
  height: 26px;
}
</style>
